<div class="not-found">
  <div class="icon">
    <md-icon>rowing</md-icon>
  </div>
  <div class="message">
    page not found
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/not-found/not-found.component.html